import React, { useEffect, useState } from "react";
import { Table, message } from "antd";
import { ColumnsType } from "antd/es/table";
import { useWorkHourModel } from "../workHourModel";
import { tableSize } from "@/utils/constants";
import { DetailModel } from "./DetailModel"
import useNavModel from "@/model/navModel";
import YhTootip from "@/components/YhTootip";
import useGlobalModel from "@/model/globalModel";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, descRows, loading,
        loadData, setSelectedRowKeys, setDescRows
    } = useWorkHourModel();
    const { selectedNavId, replaceNav } = useNavModel();
    const [detail, setDetail] = useState<{ visible: boolean, code: string }>({ visible: false, code: "" });

    useEffect(() => {
        loadData()
    }, [])

    const defaultColumns: ColumnsType<any> = [
        {
            title: '序号',
            fixed: "left",
            width: 40,
            align: 'center',
            render: (t, r, i) => i + 1
        },
        {
            title: '操作',
            key: 'action',
            width: 40,
            align: 'center',
            render: (text: any, record: any,) => <YhTootip text="明细" style={{ width: 40 }} onClick={() => { setDetail({ visible: true, code: record.technicianCode }); }} />
        },
        {
            title: '姓名',
            dataIndex: 'technicianName',
            width: 120,
            align: 'center',
        },
        {
            title: '分配点数',
            dataIndex: 'assignPoints',
            width: 120,
            align: 'center',
        },
        {
            title: '工单量',
            dataIndex: 'orderNum',
            width: 120,
            align: 'center',
        },
        {
            title: '维修单量',
            dataIndex: 'maintenanceNum',
            width: 120,
            align: 'center',
        },
        {
            title: '保养单量',
            dataIndex: 'repairNum',
            width: 120,
            align: 'center',
        },
        {
            title: '一保单量',
            dataIndex: 'oneRepairNum',
            width: 120,
            align: 'center',
        },
        {
            title: '二保单量',
            dataIndex: 'twoRepairNum',
            width: 120,
            align: 'center',
        },
        {
            title: '工单占比量',
            dataIndex: 'proportion',
            width: 120,
            align: 'center',
        },
        {
            title: '累计工时',
            dataIndex: 'workHours',
            width: 120,
            align: 'center',
        },
        {
            title: '保养工时',
            dataIndex: 'repairWorkHours',
            width: 130,
            align: 'center',
        },
        {
            title: '维修工时',
            dataIndex: 'maintenanceWorkHours',
            width: 130,
            align: 'center',
        }, {
            title: '职位',
            dataIndex: 'title',
            width: 120,
            align: 'center',
        },
        {
            title: '手机号',
            dataIndex: 'phone',
            width: 120,
            align: 'center',
        },
    ];

    //点击行选高亮
    const onRow = (record: any) => {
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };
    const onRightClick = (record: any) => {
        setDescRows([record])
        setSelectedRowKeys([record.id as string])
    }
    return (
        <>
            <Table
                bordered
                style={{ cursor: "pointer" }}
                loading={loading}
                size={tableSize}
                rowKey={record => record.technicianCode as string}
                // rowSelection={{
                //     onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
                //         setSelectedRowKeys(selectedRowKeys as string[]);
                //         setDescRows(selectedRows)
                //     },
                //     selectedRowKeys
                // }}
                columns={defaultColumns}
                dataSource={dataSource}
                pagination={{
                    showSizeChanger: true,
                    ...pgCfg,
                    defaultPageSize: 25,
                    pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                    position: ["bottomRight"],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize }).then();
                    }
                }}
                onRow={record => ({
                    onClick: () => onRow(record as any),
                    onContextMenu: (e) => {
                        e.preventDefault();
                        onRightClick(record)
                    }

                })}
                scroll={{ x: 'max-content', y: 'calc(100vh - 370px)' }}

            />

            <DetailModel
                visible={detail.visible}
                code={detail.code}
                onCancel={() => { setDetail({ visible: false, code: "" }); }}
            />
        </>
    )
}
